import { render, staticRenderFns } from "./AddEditUsersContainer.vue?vue&type=template&id=b5f7c512&scoped=true&"
import script from "./AddEditUsersContainer.vue?vue&type=script&lang=js&"
export * from "./AddEditUsersContainer.vue?vue&type=script&lang=js&"
import style0 from "./AddEditUsersContainer.vue?vue&type=style&index=0&id=b5f7c512&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f7c512",
  null
  
)

export default component.exports